<template>
    <section class="bg-[#E2ECF4]">
        <div class="max-w-4xl px-4 py-8 mx-auto md:py-16 xl:px-0">
            <div class="grid grid-cols-11 gap-x-4">
                <div class="flex flex-col justify-center col-span-12 md:col-span-6">
                    <h2
                        class="mb-4 text-3xl text-center md:text-4xl font-ww-bold xl:!leading-none xl:text-42 md:text-left"
                        v-html="mainHeading">
                    </h2>

                    <nuxt-img :src="imageSrc" :width="width" :height="height" sizes="xs:320px sm:320px md:320px lg:384pxxl:392" format="webp" loading="lazy"
                    class="object-contain h-full mx-auto lg:object-cover xl:w-full md:hidden max-w-80" :alt="imageAlt" />

                    <div class="text-base !leading-6 text-center xl:text-lg font-ww-regular md:text-left mobile-left"
                        v-html="contentText">
                    </div>
                </div>
                <div class="items-center hidden col-span-5 md:flex">
                    <nuxt-img :src="imageSrc" :width="width" :height="height" sizes="xs:320px sm:320px md:320px lg:384pxxl:392" format="webp" loading="lazy"
                        class="object-contain h-full lg:object-cover xl:w-full" :alt="imageAlt" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
  mainHeading: {
    type: String,
    default: 'The Purest, Chemical-Free Method to Remove 99.9% of Caffeine',
  },
  contentText: {
    type: String,
    default: `At Lifeboost, we believe coffee should never come at the cost of your health. That's why our
                        decaf is made using the Swiss Water® Process — a 100% natural, chemical-free method that uses
                        pure water, temperature, and time to gently remove 99.9% of the caffeine.
                        <br> <br>
                        No solvents. No toxins. Just clean, delicious decaf that retains all the rich flavor,
                        antioxidants, and gut-friendly benefits thousands of people love about our low acid regular
                        roasts.
                        <br> <br>
                        Each small batch is slow-roasted for maximum flavor, sourced from our single-origin
                        high-elevation beans grown in the shade of mountain rainforests, and tested for mycotoxins,
                        heavy metals, pesticides, and over 450 other toxins — so you can sip confidently, knowing you're
                        enjoying one of the cleanest, healthiest coffees on the planet.`,
  },
  imageSrc: {
    type: String,
    default: '/assets/images/decaf-5-1.png',
  },
  imageAlt: {
    type: String,
    default: 'Swiss Water Process Decaf Coffee',
  },
  backgroundColor: {
    type: String,
    default: '#E2ECF4',
  },
  width: {
    type: [Number, String],
    default: 392
  },
  height: {
    type: [Number, String],
    default: 604
  }
});

defineBuilderComponent({
  friendlyName: 'TextRightImage',
  inputs: [
    {
      name: 'mainHeading',
      type: 'richText',
      friendlyName: 'Main Heading',
      defaultValue: 'The Purest, Chemical-Free Method to Remove 99.9% of Caffeine',
    },
    {
      name: 'contentText',
      type: 'richText',
      friendlyName: 'Content Text',
      defaultValue: `At Lifeboost, we believe coffee should never come at the cost of your health. That's why our
                        decaf is made using the Swiss Water® Process — a 100% natural, chemical-free method that uses
                        pure water, temperature, and time to gently remove 99.9% of the caffeine.
                        <br> <br>
                        No solvents. No toxins. Just clean, delicious decaf that retains all the rich flavor,
                        antioxidants, and gut-friendly benefits thousands of people love about our low acid regular
                        roasts.
                        <br> <br>
                        Each small batch is slow-roasted for maximum flavor, sourced from our single-origin
                        high-elevation beans grown in the shade of mountain rainforests, and tested for mycotoxins,
                        heavy metals, pesticides, and over 450 other toxins — so you can sip confidently, knowing you're
                        enjoying one of the cleanest, healthiest coffees on the planet.`,
    },
    {
      name: 'imageSrc',
      type: 'file',
      friendlyName: 'Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/decaf-5-1.png',
    },
    {
      name: 'imageAlt',
      type: 'text',
      friendlyName: 'Image Alt Text',
      defaultValue: 'Swiss Water Process Decaf Coffee',
    },
    {
      name: 'backgroundColor',
      type: 'color',
      friendlyName: 'Background Color',
      defaultValue: '#E2ECF4',
    },
    {
      name: 'width',
      type: 'number',
      friendlyName: 'Image Width',
      defaultValue: 392
    },
    {
      name: 'height',
      type: 'number',
      friendlyName: 'Image Height',
      defaultValue: 604
    }
  ],
});
</script>